module.exports = __webpack_public_path__ + "static/media/no-attachments.f204d9a7.svg";